import { FC, JSX } from 'react';
import { type Id, toast as t } from 'react-toastify';

import CheckIcon from '@semcore/icon/Check/m';

interface ICustomToastProps {
  message: string;
  variant: 'success' | 'error';
}

const CustomToast: FC<ICustomToastProps> = ({
  message,
  variant,
}): JSX.Element => {
  const isError = variant === 'error';
  const iconBg = isError ? 'bg-[#F04438]' : 'bg-[#07D034]';
  const icon =
    variant === 'success' ? (
      <CheckIcon color="#FFFFFF" />
    ) : (
      <span className="text-xs font-bold text-white">!</span>
    );

  return (
    <div className="flex flex-row items-center gap-2 rounded-lg bg-black px-3 py-2">
      <div
        className={`flex h-5 w-5 items-center justify-center rounded-full ${iconBg}`}
      >
        {icon}
      </div>
      <div className="text-sm font-light text-white">{message}</div>
    </div>
  );
};

const showToast = (
  message: string,
  variant: ICustomToastProps['variant'],
  id: Id | undefined = undefined,
  autoClose: number | false | undefined = 5000
): Id => {
  return t(<CustomToast message={message} variant={variant} />, {
    position: 'bottom-center',
    autoClose,
    closeButton: false,
    hideProgressBar: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    closeOnClick: true,
    draggable: false,
    toastId: id,
    className: 'p-0 w-auto h-auto min-h-5 mb-0 bg-transparent shadow-none',
  });
};

export function toast(
  message: string,
  id: Id | undefined = undefined,
  autoClose: number | false | undefined = 5000
): Id {
  return showToast(message, 'success', id, autoClose);
}

export function toastError(
  message: string,
  id: Id | undefined = undefined,
  autoClose: number | false | undefined = 5000
): Id {
  return showToast(message, 'error', id, autoClose);
}
